import RequestAbstract from "../abstract";

export default class PayoutInstances extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payout-instances";
    }
}
